import { render } from "./ReasonModal.vue?vue&type=template&id=40b4d0b1"
import script from "./ReasonModal.vue?vue&type=script&lang=js"
export * from "./ReasonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__